import React from 'react';

function detail(props) {
  const { data } = props;

  // transform data

  return (
    <div className="main-block main-block_v2">
      <div className="wrapper">
        <article className="article-1" dir="ltr">
          <h1 className="center small-caps"> {data?.title || ''}</h1>
          <div
            className="ck-content mx-6 text-xs  md:mx-auto md:text-base rich-text-style-override"
            data-v-cf9d2e34=""
            dangerouslySetInnerHTML={{ __html: data?.description || '' }}
          />
        </article>
      </div>
    </div>
  );
}

export default detail;
